import type { ComponentType } from 'react';
import { memo } from 'react';

import { useOptions } from '../../hooks/useOptions';
import type { LbPart, LbPost } from '../../types';
/*eslint import-x/namespace: ['error', { allowComputed: true }]*/
import ErrorBoundary from '../ErrorBoundary';

import * as fallbackComponents from './index';

const PartRenderer = ({ post, part }: { post: LbPost; part: LbPart }) => {
  const { customComponents } = useOptions();

  const PartComponent: ComponentType<{ post: LbPost; part: LbPart }> =
    customComponents?.[part.datasource] ?? fallbackComponents[part.datasource];

  if (!PartComponent) return null;

  return (
    <ErrorBoundary data={{ post, part }}>
      <PartComponent post={post} part={part} />
    </ErrorBoundary>
  );
};

const PartsRenderer = ({ post, parts }: { post: LbPost; parts: LbPart[] }) => (
  <>{parts && parts.map((part, i) => <PartRenderer key={`part_${part.resourceId ?? i}`} post={post} part={part} />)}</>
);

export default memo(PartsRenderer);
